import { render, staticRenderFns } from "./ViewResult.vue?vue&type=template&id=4c4eb604&scoped=true"
import script from "./ViewResult.vue?vue&type=script&lang=js"
export * from "./ViewResult.vue?vue&type=script&lang=js"
import style0 from "./ViewResult.vue?vue&type=style&index=0&id=4c4eb604&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4eb604",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c4eb604')) {
      api.createRecord('4c4eb604', component.options)
    } else {
      api.reload('4c4eb604', component.options)
    }
    module.hot.accept("./ViewResult.vue?vue&type=template&id=4c4eb604&scoped=true", function () {
      api.rerender('4c4eb604', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/panel/subjectSetting/panelStyle/ViewResult.vue"
export default component.exports